import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import DialogHeader from "../common/DialogHeader";

const DeleteDialog = ({
  open,
  handleClose,
  handleDelete,
  loading,
  title = "this",
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { minWidth: "25vw" },
      }}
    >
      <DialogHeader title="Delete Confirmation" handleClose={handleClose} />
      <DialogContent>
        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.2rem",
              fontWeight: "500",
              color: "text.primary",
            }}
          >
            Are you sure you want to delete {title}?
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Stack direction={"row"} justifyContent={"center"} gap={2}>
          <LoadingButton
            color="secondary"
            variant="outlined"
            size="small"
            type="submit"
            onClick={() => handleClose()}
          >
            CANCEL
          </LoadingButton>
          <LoadingButton
            color="error"
            loading={loading}
            variant="contained"
            size="small"
            type="submit"
            onClick={() => handleDelete()}
          >
            CONFIRM
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteDialog;
